import React, { useState } from "react";
import axios from "axios";
import "./AddTasksForBuyTaxiDashForm.css";

const AddTasksForBuyTaxiDashForm = () => {
  const [task, setTask] = useState({
    task_name: "",
    task_date: "",
    task_description: "",
    task_area: "",
    task_page: "",
    status: "בתהליך",
    notes: "",
    execution_date: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTask((prevTask) => ({
      ...prevTask,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("/api/tasks/add", task);
      alert("✅ משימה נוספה בהצלחה!");
      console.log(response.data);
      setTask({
        task_name: "",
        task_date: "",
        task_description: "",
        task_area: "",
        task_page: "",
        status: "בתהליך",
        notes: "",
        execution_date: "",
      });
    } catch (error) {
      console.error("❌ שגיאה בהוספת המשימה:", error);
      alert("❌ שגיאה בהוספת המשימה. נסה שוב.");
    }
  };

  return (
<div className="task-form-container">
  <h2 className="task-form-title">📝 הוספת משימה חדשה</h2>
  <form onSubmit={handleSubmit} className="task-form">
    
    <label className="task-label-name">שם המשימה:</label>
    <input type="text" name="task_name" value={task.task_name} onChange={handleChange} required className="task-input-name" />

    <label className="task-label-date">תאריך יצירה:</label>
    <input type="date" name="task_date" value={task.task_date} onChange={handleChange} required className="task-input-date" />

    <label className="task-label-description">תיאור המשימה:</label>
    <textarea name="task_description" value={task.task_description} onChange={handleChange} className="task-textarea-description"></textarea>

    <label className="task-label-area">אזור המשימה:</label>
    <input type="text" name="task_area" value={task.task_area} onChange={handleChange} className="task-input-area" />

    <label className="task-label-page">עמוד המשימה:</label>
    <input type="text" name="task_page" value={task.task_page} onChange={handleChange} className="task-input-page" />

    <label className="task-label-status">סטטוס:</label>
    <select name="status" value={task.status} onChange={handleChange} required className="task-select-status">
      <option value="בוצע">בוצע</option>
      <option value="בתהליך">בתהליך</option>
      <option value="לא בוצע">לא בוצע</option>
    </select>

    <label className="task-label-notes">הערות:</label>
    <input type="text" name="notes" value={task.notes} onChange={handleChange} className="task-input-notes" />

    <label className="task-label-execution">תאריך ביצוע:</label>
    <input type="date" name="execution_date" value={task.execution_date} onChange={handleChange} className="task-input-execution" />

    <button className="task-form-submit">💾 שמירת משימה</button>
  </form>
</div>

  );
};

export default AddTasksForBuyTaxiDashForm;
